import React from 'react'

export default function ChatIndex() {
  return (
    <div>Chat</div>
  )
}
